<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    :fullscreen="fullscreen"
>
    <v-card
        v-if="message_details != null"
    >
        <v-card-title
            v-if="!fullscreen"
        >
            Message Details
        </v-card-title>

        <v-toolbar
          dark
          color="primary"
          v-if="fullscreen"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Message Details</v-toolbar-title>
         
        </v-toolbar>

        <v-card-text
            v-if="!fullscreen"
        >
            <m-card-property
                text="Time"
                :value="prettyPrintTime()"
            />

            <m-card-property
                text="Type"
                :value="prettyType(this.message_details.stored_message.content_type)"
            />

            <m-card-property
                text="From"
                :value="$rc.pretty(this.message_details.stored_message.author, 'endpoint')"
            />

            <m-card-property
                text="To"
                :value="pretty_to"
            />

            <m-card-property
                text="Content"
                v-if="message_details.stored_message.content_type != 'application/redchirp-image'"
                :value="message_details.stored_message.content"
            />

            <m-card-property
                text="Image (Media) URL"
                v-if="message_details.stored_message.content_type == 'application/redchirp-image'"
                :value="'https://files.redchirp.com/'+JSON.parse(message_details.stored_message.content).object_name"
            />

             <m-card-property
                text="Image (Media) Caption"
                :value="message_details.stored_message.image_caption"
            />

            <m-card-property
                text="SID"
                :value="this.message_details.stored_message.transport_system_id"
            />

            <m-card-property
                v-if="this.message_details.pretty_status != null && this.message_details.error_detail == null"
                text="Status"
                :value="this.message_details.pretty_status"
            />

            <m-card-property
                v-if="this.message_details.error_detail != null"
                text="Error Code"
                :value="this.message_details.error_detail.code"
            />

            <m-card-property
                v-if="this.message_details.error_detail != null"
                text="Error Description"
                :value="this.message_details.error_detail.description"
            />

            <m-card-property
                v-if="this.message_details.error_detail != null"
                text="Error Friendly Description"
                :value="this.message_details.error_detail.friendly_description"
            />

            <m-card-property
                v-if="this.message_details.error_detail != null"
                text="Error Explanation"
                :value="this.message_details.error_detail.explanation"
            />

            <m-card-property
                v-if="this.message_details.error_detail != null"
                text="Billable"
                :value="this.message_details.error_detail.billable"
            />

            <m-card-property
                v-if="this.message_details.single_endpoint_to_line_type != null"
                text="Destination Line Type"
                :value="this.message_details.single_endpoint_to_line_type"
            />

            <m-card-property
                v-if="this.message_details.single_endpoint_to_line_provider != null"
                text="Destination Line Provider"
                :value="this.message_details.single_endpoint_to_line_provider"
            />

             <m-card-property
                v-if="this.message_details.campaign_class != null"
                text="Campaign Class"
                :value="this.message_details.campaign_class"
            />

            <m-card-property
                text="RedChirp Stored Message Id"
                v-if="message_details != null && message_details.stored_message != null"
                :value="message_details.stored_message.message_id"
            />
            
            <!--
            <m-card-property
                v-if="is_system_admin"
                text="Network"
                :value="prettyPrintNetwork()"
            />
            -->
        </v-card-text>

        <v-card-text
            v-if="fullscreen"
        >
            <m-code-block
                :click_anywhere_to_copy="false"
            >
                {{pretty_print_details}}
            </m-code-block>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onMoreInformation"
                v-if="is_system_admin"
            >
            {{more_information_btn_text}}
            </v-btn>


            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            stored_message_id: null,
            message_details: null,
            fullscreen: false,
        }
    },

    methods: {

        showDialog(stored_message_id)
        {
            this.stored_message_id = stored_message_id;
            this.fullscreen = false;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/comms/message-details/:stored_message_id',
            
                'params' : {
                        'stored_message_id': stored_message_id,
                    },
            
                'on_success': (data) => {
                        this.message_details = data;
                        this.message_details.stored_message.time_pretty_print = this.prettyPrintTime();
                        this.dialog = true;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        prettyPrintTime()
        {
            return ''+new Date(this.message_details.stored_message.time);
        },

        prettyPrintNetwork()
        {
            let org_endpoints = this.message_details.org_endpoints;

            for( let i = 0; i < org_endpoints.length; i++ )
            {
                return org_endpoints[i].network;
            }

            return '';
        },

        onMoreInformation()
        {
            this.fullscreen = !this.fullscreen;
        },

        prettyType(type)
        {
            if ( type == null ) 
                return null;

            type = type.toLowerCase();
            
            if ( type == 'text/plain' ) 
            {
                return "SMS (text/plain)";
            }

            if ( type == 'application/redchirp-long-plain-text' || type == 'application/redchirp-image' || type == 'application/redchirp-payment-message' || type == 'application/redchirp-file' ) 
            {
                return "MMS ("+type+")";
            }

            return type;
        }
    },

    computed: {
        is_system_admin() {
            return this.$rc.$state.isAuthActorSystemAdmin();
        },

        pretty_print_details() {
            return JSON.stringify(this.message_details, null, 2);
        },

        more_information_btn_text() {
            if ( this.fullscreen == true ) return 'Less Information';
            return 'More Information';
        },

        pretty_to() {
            let author = this.message_details.stored_message.author;

            let all = this.message_details.conversation_definition.endpoints;

            let ret = '';

            for ( let i = 0; i < all.length; i++ )
            {
                if ( all[i] == author ) 
                continue;

                if ( ret.length == 0 )
                {
                    ret = this.$rc.pretty(all[i],'endpoint');
                }
                else
                {
                    ret += ', '+this.$rc.pretty(all[i],'endpoint');
                }
            }

            return ret;
        },

        
    },
}
</script>

<style lang="scss" scoped>
</style>